// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Nfhxt","button--reversed":"Button_button--reversed__OSF-l","button--small":"Button_button--small__3SoV5","loader":"Button_loader__1gqyy"};